<app-header *ngIf="isUserDefined && !isLoginPage && loadHeader" class="top-bar-collapsed header-tbc"></app-header>
<service-select-panel [reloadServices]="reloadServices" [userId]="userId"
                      *ngIf="isUserDefined && !isLoginPage && !this.store.state.common.serviceId && !hideServices">
</service-select-panel>
<app-sidenav *ngIf="isUserDefined && !isLoginPage && loadHeader"
    [userName]="userName"
    [userEmail]="userEmail"
    [userInitial]="userInitial"
    [systemProperties]="systemProperties"
    [serviceId]="store.state.common.serviceId || null"
    [serviceName]="store.state.common.serviceName || null"
    [defaultMyAccountServiceId]="store.state.common.defaultMyAccountServiceId || null"
    [logout]="logout"></app-sidenav>
<div class="container-fluid {{store.state.common.sidemenuSmall ? 'sidemenu-small' : ''}} {{!hideSidenav ? 'service-content' : ''}} {{this.store.state.common.serviceId ? 'content-tbc' : ''}}"
     [ngClass]="wrapperCssClass">
    <section id="content"
             class="row h-100">
        <ng-content></ng-content>
    </section>
</div>
